export class Footer {
    constructor() {
        this.FOOTER_SELECTOR = "footer#footer";
    }
}
